import React, { FunctionComponent } from 'react'
import { Card, PageHeader } from 'antd'
import { Trans, useTranslation } from 'react-i18next'
import { InfoCircleOutlined } from '@ant-design/icons'

import useMe from 'shared/hooks/useUser'

import styles from './styles.module.less'
import Info from './components/Info'
import EditForm from './components/EditForm'

const UserDashboard: FunctionComponent = () => {
    const { t } = useTranslation('APP')
    const { userStore } = useMe()

    return (
        <PageHeader className={`${styles.wrapper} pageHeader-global`} title={t('APP:views.userDashboard.title')}>
            <div style={{ minWidth: '400px', minHeight: '300px' }}>
                <Info user={userStore?.user} />
            </div>
        </PageHeader>
    )
}

export default UserDashboard
